var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import FormModal from '@/common/components/Modal/FormModal.vue';
import FormSelect from '@/common/components/Form/FormSelect.vue';
import FormRadio from '@/common/components/Form/FormRadio.vue';
import FormInput from '@/common/components/Form/FormInput.vue';
import { deepCopy } from '@lhb/func';
import { _post } from '@/common/request/index';
import { crmContractCancelAPI, } from '@/api/crm/contract';
var ContractCancelModal = /** @class */ (function (_super) {
    __extends(ContractCancelModal, _super);
    function ContractCancelModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /* data */
        _this.showDialog = false;
        _this.loading = false;
        _this.options = [];
        _this.reasonsMap = new Map();
        _this.form = {
            duty: '',
            reason: '',
            mark: ''
        };
        _this.rules = {
            'duty': [
                { required: true, message: '请选择责任方', trigger: ['blur', 'change'] },
            ],
            'reason': [
                { required: true, message: '请选择拒绝原因', trigger: ['blur', 'change'] },
            ],
        };
        return _this;
    }
    Object.defineProperty(ContractCancelModal.prototype, "reasonOptions", {
        get: function () {
            if (this.form.duty && this.reasonsMap.get(this.form.duty)) {
                return this.reasonsMap.get(this.form.duty);
            }
            return [];
        },
        enumerable: false,
        configurable: true
    });
    ContractCancelModal.prototype.mounted = function () {
        this.init();
    };
    /* method */
    ContractCancelModal.prototype.show = function () {
        this.showDialog = true;
    };
    ContractCancelModal.prototype.init = function () {
        var _this = this;
        _post('/property/orderReasons', { orderType: 1 }).then(function (res) {
            _this.options = res.map(function (data) {
                var name = data.name, id = data.id, _a = data.items, items = _a === void 0 ? [] : _a;
                var newItems = items.map(function (item) { return ({ label: item.name, value: item.id }); });
                _this.reasonsMap.set(id, newItems);
                return {
                    label: name,
                    value: id,
                };
            });
            _this.form.duty = _this.options.length ? _this.options[0].value : '';
        });
    };
    ContractCancelModal.prototype.changeHandler = function () {
        this.form.reason = '';
    };
    // 点击提交按钮
    ContractCancelModal.prototype.submit = function () {
        var _this = this;
        this.$refs.submitForm.validate(function (valid) {
            if (!valid) {
                _this.$message({
                    type: 'error',
                    message: "\u4FE1\u606F\u672A\u586B\u5199\u5B8C\u6574\uFF0C\u8BF7\u68C0\u67E5",
                });
                return false;
            }
            else {
                _this.postSubmit();
            }
        });
    };
    // 提交
    ContractCancelModal.prototype.postSubmit = function () {
        var _this = this;
        var params = this.paramsHandle();
        if (this.loading)
            return false;
        this.loading = true;
        window.LHBbigdata.send({
            event_id: 'd88c8881-ba65-44da-b695-649398fbeb20',
            msg: {
                operation: '点击活动作废',
            },
        });
        crmContractCancelAPI(params).then(function (res) {
            _this.$crmMessage.success('操作成功');
            _this.$emit('cancel');
            _this.showDialog = false;
        }).catch(function () { }).finally(function () {
            _this.loading = false;
        });
    };
    ContractCancelModal.prototype.paramsHandle = function () {
        var params = deepCopy(this.form);
        return __assign(__assign({}, params), { contractId: this.contractId });
    };
    ContractCancelModal.prototype.beforeClose = function () {
        this.showDialog = false;
        this.loading = false;
    };
    __decorate([
        Prop({ type: [Number, String], default: '' })
    ], ContractCancelModal.prototype, "contractId", void 0);
    ContractCancelModal = __decorate([
        Component({
            components: {
                FormModal: FormModal,
                FormRadio: FormRadio,
                FormSelect: FormSelect,
                FormInput: FormInput
            },
        })
    ], ContractCancelModal);
    return ContractCancelModal;
}(Vue));
export default ContractCancelModal;
